{
    "title": "Create Transfer",
    "subtitle": "Please provide the recipient's information to proceed with the transfer",
    "assetselected": "Asset Selected:"
}